import request from '@/plugin/axios'

export function page(query) {
return request({
url: '/api/admin/town/page',
method: 'get',
params: query
})
}
export function townList(param){
    return request({
        url:"/api/admin/town/selectList",
        method:'get',
        params:param
    })
}

export function getTree(obj){
    return request({
        url:"/api/admin/town/treeList",
        method: 'post',
        params: obj
    });
}


export function addObj(obj) {
return request({
url: '/api/admin/town',
method: 'post',
data: obj
})
}

export function getObj(id) {
return request({
url: '/api/admin/town/' + id,
method: 'get'
})
}

export function delObj(id) {
return request({
url: '/api/admin/town/' + id,
method: 'delete'
})
}

export function putObj(id, obj) {
return request({
url: '/api/admin/town/' + id,
method: 'put',
data: obj
})
}
